export default __webpack_public_path__ + "static/media/cross.485ec0bb.png";